// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"index-module__Spinner___wF4Um","brand":"index-module__brand___EWW5R"};